:host {
  display: block;
}

.giftcard-form {
  .amount {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-bottom: 30px;
  }

  label {
    font-size: 50px;
    line-height: 1;
    font-weight: 500;
  }

  input {
    height: 60px;
    font-size: 20px;
    padding: 0 20px;
    width: 80px;
    border: 1px solid var(--color-livique-anthrazit);
    color: var(--color-livique-anthrazit);
    font-family: var(--primary-font), sans-serif;
  }
}

input[type='radio'] {
  display: none;
}

.link {
  float: right;
  margin-bottom: 20px;
  cursor: pointer;
}

.pickup,
.delivery {
  cursor: pointer;
}

.pickup {
  margin-bottom: 12px;
}

.action {
  display: grid;
  grid-template-columns: 60px auto 46px;
  gap: 16px;
  position: relative;

  .wishlist {
    display: grid;
    align-items: center;
    border: 1px solid var(--color-nero);
  }
}

.selection {
  margin-bottom: 24px;
}

::slotted(.pickup-container) {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
